export default {"src":"/_next/static/media/instagram.64ad5c8f.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};